exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".services-meta{display:flex;flex-wrap:wrap;margin-left:-20px;margin-right:-20px}.services-meta>*{margin:10px 20px}.services-meta a{text-decoration:underline}", ""]);
